import {ContentSetOverviewResultVo} from '../../common/shared/api/nicolas/vo/ContentSetOverviewResultVo.interface';
import {ContentSetOverview, Maybe, User} from '../generated/types';
import {createPosterViewItem} from './PosterViewItem';
import {createSeries} from './Series';
import {createSet} from './Set';

export function createContentSetOverview(
  userInfo: Maybe<User>,
  {series, product_list, set}: ContentSetOverviewResultVo
): ContentSetOverview {
  return {
    series: createSeries(series),
    productList: product_list.map(product =>
      createPosterViewItem(userInfo, {setProductDto: product})
    ),
    set: createSet(set),
  };
}
